import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { koKR } from '@mui/x-date-pickers/locales';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/ko';
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

import { getStatistic } from 'services/api-service/center';
import ManagerTable from './ManagerTable';

const ManagerDispatch = () => {
  const [datas, setDatas] = useState<any[] | undefined>(undefined);
  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs().subtract(1, 'month'));
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());

  const onSearch = async () => {
    if (!startDate || !endDate) {
      alert('날짜를 선택해 주세요.');
      return;
    }
    const monthDiff = endDate.diff(startDate, 'month', true);
    if (monthDiff > 2) {
      alert('최대 조회 기간은 2개월입니다.');
      return;
    }
    if (startDate.isAfter(endDate)) {
      alert('시작일은 종료일보다 빨라야 합니다.');
      return;
    }
    try {
      const startStr = startDate.format('YYYYMMDD');
      const endStr = endDate.format('YYYYMMDD');
      const response: any = await getStatistic('P', startStr, endStr);
      if (response.result === 'success') {
        setDatas(response.datas);
      }
    } catch (error) {
      console.log('getStaticstics Error ', error);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: '구조대 출동 실적',
        columns: [
          {
            Header: 'No',
            accessor: (row, i) => i + 1,
            id: 'number',
          },
          {
            accessor: 'dateTime',
            Header: '동원일시',
          },
          {
            accessor: 'dLoc',
            Header: '동원장소',
          },
          {
            accessor: 'wCond',
            Header: '기상상태',
          },
          {
            accessor: 'accType',
            Header: '사고유형',
          },
          {
            accessor: 'dType',
            Header: '동원유형',
          },
          {
            accessor: 'dRoute',
            Header: '동원경로',
          },
          {
            accessor: 'name',
            Header: '대원명',
          },
          {
            accessor: 'phone',
            Header: '연락처',
          },
          {
            accessor: 'levelANm',
            Header: '지방청',
          },
          {
            accessor: 'levelBNm',
            Header: '소속서',
          },
          {
            accessor: 'levelCNm',
            Header: '파출소',
          },
          {
            accessor: 'special1',
            Header: '전문분야1',
          },
          {
            accessor: 'special2',
            Header: '전문분야2',
          },
        ],
      },
    ],
    []
  );

  useEffect(() => {
    onSearch();
  }, []);

  return (
    <ManagerDispatchTemplate>
      <TitleWrap>출동실적 통계</TitleWrap>
      <SearchWrap>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="ko"
          localeText={koKR.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          <CustomDateField
            value={startDate}
            format={'YYYY-MM-DD'}
            maxDate={dayjs()}
            onChange={(newValue: any) => setStartDate(newValue)}
          />
          <Separator>~</Separator>
          <CustomDateField
            value={endDate}
            format={'YYYY-MM-DD'}
            maxDate={dayjs()}
            onChange={(newValue: any) => setEndDate(newValue)}
          />
          <DayButton onClick={onSearch}>조회</DayButton>
        </LocalizationProvider>
      </SearchWrap>
      <TableWrap>
        {datas !== undefined && datas.length >= 1 ? (
          <ManagerTable columns={columns} data={datas} supportSort={true} />
        ) : (
          <EmptyText>데이터가 없습니다.</EmptyText>
        )}
      </TableWrap>
    </ManagerDispatchTemplate>
  );
};

const ManagerDispatchTemplate = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`;
const TitleWrap = styled.div`
  text-align: center;
  align-content: center;
  width: 18.75rem;
  height: 3.4375rem;
  cursor: pointer;
  background: radial-gradient(#cf1900, #000000);
  border-radius: 0.625rem;
  border: 1px solid;
  border-color: #cf1900;
  color: #ffffff;
  font-family: Inter;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  margin: 4rem auto;
`;
const SearchWrap = styled.div`
  width: 90%;
  min-width: 71.875rem;
  height: 4rem;
  margin: auto;
`;
const Separator = styled.span`
  color: #ffffff;
  font-weight: bold;
  margin: 0 10px;
`;
const TableWrap = styled.div`
  width: 90%;
  min-width: 71.875rem;
  height: calc(100% - 25rem);
  border: 1px solid #000000;
  margin: auto;
`;
const EmptyText = styled.h1`
  margin-top: 10rem;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.375rem;
  color: #ffffff;
  text-align: center;
`;
const CustomDateField = styled(DatePicker)`
  display: flex;
  justify-content: center;

  .MuiInputBase-root {
    width: 8.5625rem;
    height: 2.25rem;
    bottom: 0;
    border-radius: 0.3125rem;
    border: 1px solid #ddd;
    background: rgba(255, 255, 255, 0.3);
    font-family: '' Inter '';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
    :focus {
      outline: 0;
    }
  }
  .MuiOutlinedInput-root button {
    padding: 0px 2px 0px 0px;
  }
  .MuiSvgIcon-root {
    color: #ffffff;
  }
  .MuiOutlinedInput-root fieldset {
    border: 0;
  }
  .MuiOutlinedInput-input {
    text-align: center;
    padding: 0px 0px 0px 5px;
  }
`;
const DayButton = styled.button`
  width: 3.4375rem;
  height: 2.25rem;
  margin-left: 2rem;
  padding: 0px;
  border-radius: 5px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 2.25rem;
  color: #ffffff;
  border-radius: 0.3125rem;
  border: 1px solid #ddd;
  background: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  z-index: 1;
`;

export default ManagerDispatch;
